import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="comment">
                1.&nbsp;<span className="material-symbols-outlined">tag</span>&nbsp;{translate('comment')}
            </Typography>
            <p><strong>{translate('comment')}</strong> được sử dụng để chú thích ý nghĩa của kịch bản và làm cho nó dễ đọc hơn.</p>

            <Typography variant="h5" gutterBottom id="setvariable">
                2.&nbsp;<span className="material-symbols-outlined">save</span>&nbsp;{translate('setvariable')}
            </Typography>
            <p><strong>{translate('setvariable')}</strong> được sử dụng để chứa dữ liệu tạm thời.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và có thể đem ra sử dụng ở những hành động khác.</td>
                                <td>$variableName_1</td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Là giá trị muốn lưu trữ.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Ví dụ tạo biến có <strong>{translate('outputkey')}</strong> là <strong>$todayIs</strong> lưu trữ giá trị <i>Today is</i>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$todayIs</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div>Today is</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Today is</div>
                        </div>
                    </div>
                    <p>Chúng ta có thể chỉ định các phép tính bằng cách kết hợp các hàm số có sẵn và các <strong>{translate('outputkey')}</strong>.</p>
                    <p>Tạo thêm biến có <strong>{translate('outputkey')}</strong> là <strong>$result</strong> lưu trữ giá trị của <strong>$todayIs</strong> kết hợp với hàm số lấy giá trị ngày hôm nay.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$result</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>$todayIs + " " + GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span></div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>{"Today is " + FormatDate(new Date(), "yyyy-MM-dd")}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);